<script lang="ts">
	import WizardWrapperEditableObject from 'src/components/ModalWizzard/WizardWrapperEditableObject.svelte';
	import { capFirstChar } from 'src/helpers/utilities';
	import { format } from 'svelte-i18n';
	import DayPickerStep from './WizardSteps/Schedules/DayPickerStep.svelte';
	import TimePickerStep from './WizardSteps/Schedules/TimePickerStep.svelte';
	import ActionTemperatureStep from './WizardSteps/Schedules/ActionTemperatureStep.svelte';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { prepareScheduleToSend } from './helpers';
	import { createEventDispatcher } from 'svelte';

	export let showModal, editableObject;
	const dispatcher = createEventDispatcher();

	$: wizardItems = [
		{
			active: editableObject.activeIndex === 0,
			activeIndex: 0,
			disabled: false,
			showMoreDots: false,
			stepNumber: 1,
			title: $format('schedules_wizard_items_week_days', {
				default: 'Week days',
			}),
			subtitle: $format('choose_active_days', {
				default: 'Choose active days',
			}),
			tooltipTitle: $format('choose_active_days'),
			component: DayPickerStep,
		},
		{
			active: editableObject.activeIndex === 1,
			activeIndex: 1,
			disabled: false,
			showMoreDots: false,
			stepNumber: 2,
			title: capFirstChar($format('schedules_wizard_items_time', { default: 'Time' })),
			subtitle: capFirstChar(
				$format('choose_start_time', {
					default: 'Choose start time',
				}),
			),
			component: TimePickerStep,
			tooltipTitle: capFirstChar($format('choose_time')),
		},
		{
			active: editableObject.activeIndex === 2,
			activeIndex: 2,
			disabled: false,
			showMoreDots: false,
			stepNumber: 3,
			title: capFirstChar(
				$format('schedules_wizard_items_temperature', {
					default: 'Temperature',
				}),
			),
			subtitle: $format('choose_thermostat_temp_label', {
				default: 'Choose temperature',
			}),
			component: ActionTemperatureStep,
			tooltipTitle: $format('select_type', {
				values: { type: $format('process_temperature_schedule') },
			}),
		},
	];
	const closeModal = () => {
		showModal = false;
	};
	let validation = {
		0: {
			disabled: false,
		},
		1: {
			disabled: false,
		},
		2: {
			disabled: false,
		},
	};
	// $: console.warn('editableObject from schedules', editableObject);

	const saveSchedule = async () => {
		const device = editableObject.device;

		const config = prepareScheduleToSend(editableObject.schedule);

		const res = await gen2Request(editableObject.device, 'Thermostat.Schedule.ChangeRule', {
			...config,
		});
		onSettingsResponse(res, device);
		if (res.isok) dispatcher('save');
	};
</script>

<WizardWrapperEditableObject
	bind:showModal
	on:close={closeModal}
	title={capFirstChar(
		$format('title_edit_schedule', {
			default: 'Edit schedule',
		}),
	)}
	bind:wizardItems
	bind:validation
	bind:editableObject
	callback={saveSchedule}
/>
